export const english = {
  language: "english",

  indexTitle: "Bowling Val Thorens",
  metaDescription:
    "In the centre of the Val Thorens, come and discover the bowling lanes, the game room and the live sport matches.",

  welcome: "Welcome",
  reservation: "Reserve",
  activities: "Activities",
  pool: "Pool",
  gameRoom: "Game room",

  introText1:
    "In the centre of the Val Thorens, come and discover the various activities offered by the Val Thorens Bowling.",
  introText2:
    "'La Bicicleta' Sports Bar offers you 8 screens (up to 120 inches) and broadcasts all major sporting events live, and in the basement, you'll find a large game room.",
  openingHours:
    "Open every day from 4 PM to 2 AM and on Saturdays from 10 AM to 2 AM.",

  saturday: "Saturday",
  sunday: "Sunday",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",

  jan: "Jan",
  feb: "Feb",
  mar: "March",
  apr: "April",
  may: "May",
  june: "June",
  july: "July",
  aug: "Aug",
  sept: "Sept",
  oct: "Oct",
  nov: "Nov",
  dec: "Dec",

  nextWeek: "Next",
  lastWeek: "Previous",

  weekProgram: "program of the week",

  activity1Description1:
    "8 ultra-modern and QUBICA AMF approved bowling lanes at your disposal.",
  activity1Description2:
    "At night, the lanes come alive with a fluorescent atmosphere. Guaranteed fun!",
  activity1Description3: "All lanes are equipped with barriers.",
  activity1Price1: "1 game of bowling	- 13,00 € / person",
  activity1Price2: "2 games of bowling	- 20,00 € / person",

  activity2Description1:
    "Every day during the winter, the most exciting sports events are broadcast live.",
  activity2Description2:
    "Comfort is guaranteed at the 'La Bicicleta' sports bar thanks to multiple screens. Nothing is impossible at 'La Bicicleta.' Modern equipment technology allows you to watch up to 4 sports events simultaneously...",
  activity2Description3: "Mojito party every Monday - Mojito for €8.",

  activity3Description1:
    "A wide variety of billiards for endless enjoyment await you in our two billiards rooms",
  activity3Description2: "5 english pool tables (8 ball) of 7 feet",
  activity3Description3: "3 american pool tables of 9 feet",
  activity3Price1: "1 game of pool	- 4,00 €",
  activity3Price2: "6 games of pool	- 20,00 €",

  activity4Description1: "Numerous games are at your disposal:",
  activity4Description2: "air hockey - foosball - street basket",
  activity4Description3: "video games - racing games",

  instaTitle: "LATEST NEWS",
  contactTitle: "REACH THE BOWLING",

  cookieHeader: "WE VALUE YOUR PRIVACY!",
  cookieText: "This website uses cookies to analyze our traffic.",
  cookieAccept: "I accept!",
  cookieDecline: "I decline..",

  rights: "All rights reserved",
  legal: "Disclaimer",
};
